'use strict';

var get = require('./get');
var set = require('./set');

module.exports = function(opt_prefix) {
  var prefix = opt_prefix || '';
  return {
    get: function(name) {
      return get(prefix + name);
    },
    set: function(name, value, time) {
      set(prefix + name, value, time);
    },
    del: function(name) {
      set(prefix + name, 0, 0);
    },
    fullName: function(name) {
      return prefix + name
    }
  };
};



//////////////////
// WEBPACK FOOTER
// ./lib/cookies/index.js
// module id = 8
// module chunks = 1 3